import { createBalanceStore } from './create-balance-store';

export const { useBalanceStore: useUserBalanceStore, useHasEnoughMinutesToDub: useUserHasEnoughMinutesToDub } =
  createBalanceStore();
